import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import { DescriptionTypography } from '@/components/LoginDialog/components';
import { MainTextTypography } from '@/components/RecoveryDialog/components';
import Form from '@/components/RecoveryDialog/Form';
import { ERecovery } from '@/layouts/SecondRootLayout';

interface IFirstStep {
  handleNextStep: () => void;
}

const FirstStep: FC<IFirstStep> = ({ handleNextStep }) => {
  const { t } = useTranslation('login', {
    keyPrefix: 'passwordRecovery.firstStep',
  });

  return (
    <Stack
      spacing="20px"
      width="100%"
      justifyContent="center"
      alignItems="center"
    >
      <Stack spacing="16px" width="100%" justifyContent="center" alignItems="center">
          <MainTextTypography>{t('mainText')}</MainTextTypography>
          <DescriptionTypography>
            <Trans t={t} i18nKey="description" />
          </DescriptionTypography>
      </Stack>

      <Form
        step={ERecovery.FirstStep}
        buttonText={t('buttonText')}
        handleNextStep={handleNextStep}
      />
    </Stack>
  );
};

export default FirstStep;
